import api from "../api";

// API path to the forms service
const path = "tenantConfig";

/**
 * Get a form instance
 *
 * @param tenant of current app
 */
const getAuthType = async (tenant: string) =>
	api.request({
		method: "GET",
		url: `${path}/authtype/${tenant}`,
	});

/**
 * Get backend type of user
 *
 * @param tenant of current app
 */
const getBackendType = async (tenant: string) => {
	const authType = await getAuthType(tenant);

	if (
		authType !== undefined &&
		authType.data !== undefined &&
		authType.data.data !== undefined &&
		authType.data.data.backendType !== undefined
	) {
		return authType.data.data.backendType;
	} else {
		return "invalid";
	}
};

export default {
	getAuthType,
	getBackendType,
};
